<template>
	<div>
		<div class="row mb-3">
			<div class="col-12 col-md-6 col-lg-8">
				<h1><em class="fas fa-bus-alt"></em> {{config.year}}-{{config.year + 1}} Choice of School Transportation Request: {{student.registration_choice_of_school_id}}</h1>
			</div>
			<div class="col-12 col-md-6 col-lg-4 text-right">
				<router-link to="/admin/choice-of-school" class="btn btn-primary"><em class="fas fa-times"></em> Close</router-link>
			</div>
		</div>

		<fieldset>
			<legend>Student Information</legend>

			<div class="form-row">
				<div class="col-12 col-lg-6">
					<div class="form-row mb-2">
						<div class="col-12 col-md-6 col-lg-4">
							<label>Student ID</label>
						</div>
						<div class="col-12 col-md-6 col-lg-8">
							{{student.student_id}}
						</div>
					</div>
				</div>
				<div class="col-12 col-lg-6">
					<div class="form-row mb-2">
						<div class="col-12 col-md-6 col-lg-4">
							<label>Date of Birth</label>
						</div>
						<div class="col-12 col-md-6 col-lg-8">
							{{student.dob + "T09:00:00" | longDate}}
						</div>
					</div>
				</div>
			</div>
			<div class="form-row">
				<div class="col-12 col-lg-6">
					<div class="form-row mb-2">
						<div class="col-12 col-md-6 col-lg-4">
							<label>School</label>
						</div>
						<div class="col-12 col-md-6 col-lg-8">
							{{schoolName(student.school_id)}}
						</div>
					</div>
				</div>
				<div class="col-12 col-lg-6">
					<div class="form-row mb-2">
						<div class="col-12 col-md-6 col-lg-4">
							<label>Grade</label>
						</div>
						<div class="col-12 col-md-6 col-lg-8">
							{{student.grade}}
						</div>
					</div>
				</div>
			</div>

			<div class="form-row">
				<div class="col-12 col-lg-6">
					<div class="form-row mb-2">
						<div class="col-12 col-md-6 col-lg-4">
							<label>School Board</label>
						</div>
						<div class="col-12 col-md-6 col-lg-8">
							{{student.district_id}}
						</div>
					</div>
				</div>
			</div>

			<div class="form-row">
				<div class="col-12 col-lg-6">
					<div class="form-row mb-2">
						<div class="col-12 col-md-6 col-lg-4">
							<label>First Name</label>
						</div>
						<div class="col-12 col-md-6 col-lg-8">
							{{student.fname}}
						</div>
					</div>
				</div>
				<div class="col-12 col-lg-6">
					<div class="form-row mb-2">
						<div class="col-12 col-md-6 col-lg-4">
							<label>Last Name</label>
						</div>
						<div class="col-12 col-md-6 col-lg-8">
							{{student.lname}}
						</div>
					</div>
				</div>
			</div>
			<div class="form-row">
				<div class="col-12 col-lg-6">
					<div class="form-row mb-2">
						<div class="col-12 col-md-6 col-lg-4">
							<label>Street Number</label>
						</div>
						<div class="col-12 col-md-6 col-lg-8">
							{{student.street_number}}
						</div>
					</div>
				</div>
				<div class="col-12 col-lg-6">
					<div class="form-row mb-2">
						<div class="col-12 col-md-6 col-lg-4">
							<label>Apartment</label>
						</div>
						<div class="col-12 col-md-6 col-lg-8">
							{{student.apartment}}
						</div>
					</div>
				</div>

				<div class="col-12 col-lg-6">
					<div class="form-row mb-2">
						<div class="col-12 col-md-6 col-lg-4">
							<label>Street Name</label>
						</div>
						<div class="col-12 col-md-6 col-lg-8">
							{{student.street_name}}
						</div>
					</div>
				</div>
			</div>

			<div class="form-row">
				<div class="col-12 col-lg-6">
					<div class="form-row mb-2">
						<div class="col-12 col-md-6 col-lg-4">
							<label>City</label>
						</div>
						<div class="col-12 col-md-6 col-lg-8">
							{{student.city}}
						</div>
					</div>
				</div>
				<div class="col-12 col-lg-6">
					<div class="form-row mb-2">
						<div class="col-12 col-md-6 col-lg-4">
							<label>Postal Code</label>
						</div>
						<div class="col-12 col-md-6 col-lg-8">
							{{student.postalcode}}
						</div>
					</div>
				</div>
			</div>
		</fieldset>

		<fieldset>
			<legend>Parent/Guardian Electronic Signature and Contact Information</legend>

			<div class="form-row">
				<div class="col-12 col-lg-6">
					<div class="form-row mb-2">
						<div class="col-12 col-md-6 col-lg-4">
							<label>First Name</label>
						</div>
						<div class="col-12 col-md-6 col-lg-8">
							{{student.applicant_fname}}
						</div>
					</div>
				</div>
				<div class="col-12 col-lg-6">
					<div class="form-row mb-2">
						<div class="col-12 col-md-6 col-lg-4">
							<label>Last Name</label>
						</div>
						<div class="col-12 col-md-6 col-lg-8">
							{{student.applicant_lname}}
						</div>
					</div>
				</div>
			</div>

			<div class="form-row">
				<div class="col-12 col-lg-6">
					<div class="form-row mb-2">
						<div class="col-12 col-md-6 col-lg-4">
							<label>Phone Number</label>
						</div>
						<div class="col-12 col-md-6 col-lg-8">
							<a :href="'tel:' + student.applicant_phone" target="_blank">{{student.applicant_phone | phoneDisplay}}</a>
						</div>
					</div>
				</div>
				<div class="col-12 col-lg-6">
					<div class="form-row mb-2">
						<div class="col-12 col-md-6 col-lg-4">
							<label>Email Address</label>
						</div>
						<div class="col-12 col-md-6 col-lg-8">
							<a :href="'mailto:' + student.applicant_email" target="_blank">{{student.applicant_email}}</a>
						</div>
					</div>
				</div>
			</div>

			<div class="form-row">
				<div class="col-12 col-lg-6">
					<div class="form-row mb-2">
						<div class="col-12 col-md-6 col-lg-4">
							<label>Date</label>
						</div>
						<div class="col-12 col-md-6 col-lg-8">
							{{student.created | longDateTime}}
						</div>
					</div>
				</div>
			</div>
		</fieldset>

		<form @submit.prevent="save()">
			<fieldset>
				<legend>Internal Information</legend>

				<div class="form-row mb-2">
					<div class="col-12 col-md-6 col-lg-4">
						<label for="status">Status</label>
					</div>
					<div class="col-12 col-md-6 col-lg-8">
						<div class="btn-group d-flex justify-content-between d-block w-100" role="group" aria-label="Owned, leased, or financed">
							<button type="button" class="btn" :class="{'btn-primary': student.status == 'P', 'btn-secondary': student.status != 'P'}" @click="student.status = 'P'">
								<em class="fas fa-fw" :class="{'fa-check-circle': student.status == 'P', 'fa-circle-o': student.status != 'P'}"></em>
								Pending
							</button>
							<button type="button" class="btn" :class="{'btn-success': student.status == 'A', 'btn-secondary': student.status != 'A'}" @click="student.status = 'A'">
								<em class="fas fa-fw" :class="{'fa-check-circle': student.status == 'A', 'fa-circle-o': student.status != 'A'}"></em>
								Approved
							</button>
							<button type="button" class="btn" :class="{'btn-danger': student.status == 'D', 'btn-secondary': student.status != 'D'}" @click="student.status = 'D'">
								<em class="fas fa-fw" :class="{'fa-check-circle': student.status == 'D', 'fa-circle-o': student.status != 'D'}"></em>
								Declined
							</button>
						</div>
					</div>
				</div>

				<div class="form-row mb-2">
					<div class="col-12 col-md-6 col-lg-4">
						<label for="notes">Notes</label>
					</div>
					<div class="col-12 col-md-6 col-lg-8">
						<textarea name="notes" id="notes" v-model="student.notes" class="form-control"></textarea>
					</div>
				</div>

				<div class="form-row">
					<div class="col-12 text-center">
						<button type="submit" class="btn btn-primary mr-1"><em class="fas fa-save"></em> Save</button>
						<router-link to="/admin/choice-of-school" class="btn btn-secondary ml-1"><em class="fas fa-times"></em> Close</router-link>
					</div>
				</div>
			</fieldset>
		</form>
	</div>
</template>

<script>
export default
{
	name: 'FormChoiceOfSchool',
	data: function()
	{
		return {
			student: {
				student_id: null,
				dob: null,
				school_id: null,
				grade: null,
				fname: null,
				lname: null,
				district_id: null,
				street_number: null,
				street_name: null,
				apartment: null,
				city: null,
				postalcode: null,
				applicant_fname: null,
				applicant_lname: null,
				applicant_phone: null,
				applicant_email: null,
				applicant_tos: false,
			},
			schools: [],
			config: {
				year: 2023
			}
		}
	},
	mounted: function()
	{
		this.config.year = this.NSTS_CONFIG.year;
		this.loadSchools();
		this.loadForm(this.$route.params.registration_choice_of_school_id);
	},
	methods:
	{
		loadForm: function(registration_choice_of_school_id)
		{
			var vm = this;
			vm.startLoading();

			vm.CORS('GET', "/registration/forms/choice-of-school/" + registration_choice_of_school_id, null,
			function(data)
			{
				vm.student = data;
				vm.stopLoading();
			}, function(response)
			{
				vm.stopLoading();
				vm.showError("Error", "Error loading registration form: " + response.responseText, true, null);
			});
		},
		save: function()
		{
			var vm = this;
			vm.startLoading();

			vm.CORS('PUT', "/registration/forms/choice-of-school/" + vm.student.registration_choice_of_school_id, JSON.stringify(vm.student),
			function(data)
			{
				vm.student = data;
				vm.stopLoading();
			}, function(response)
			{
				vm.stopLoading();
				vm.showError("Error", "Error saving registration form: " + response.responseText, true, null);
			});
		},
		loadSchools: function()
		{
			var vm = this;
			vm.startLoading();

			vm.CORS('GET', "/registration/schools", null,
			function(data)
			{
				vm.schools = data;
				vm.stopLoading();
			}, function(response)
			{
				vm.stopLoading();
				vm.showError("Error", "Error loading user schools: " + response.responseText, true, null);
			});
		},
		schoolName: function(school_id)
		{
			for(var i=0; i<this.schools.length; i++)
			{
				if(this.schools[i].school_id == school_id)
				{
					return this.schools[i].school_name;
				}
			}

			return school_id;
		}
	}
}
</script>
